import React from "react";
import { Award, History, Leaf, Heart } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "Calidad Suprema",
  description: "Seleccionamos rigurosamente cada aceituna para garantizar un aceite de oliva virgen extra de sabor y aroma inigualables.",
  icon: <Award className="w-12 h-12" />
}, {
  title: "Tradición Familiar",
  description: "Honramos el legado de generaciones dedicadas al cuidado del olivar, manteniendo métodos artesanales con tecnología actual.",
  icon: <History className="w-12 h-12" />
}, {
  title: "Sostenibilidad",
  description: "Cultivamos nuestras tierras con profundo respeto por el medio ambiente, preservando la biodiversidad de nuestro entorno.",
  icon: <Leaf className="w-12 h-12" />
}, {
  title: "Pasión por el Campo",
  description: "El amor por la naturaleza y la agricultura se refleja en cada gota, ofreciendo un producto auténtico y lleno de vida.",
  icon: <Heart className="w-12 h-12" />
}];
export default function BrandValuesFourPillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="brand-values-four-pillars" className="section bg-background relative overflow-hidden ![padding:60px_0px_80px_0px]">
      <div className="container relative z-10">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="text-center mb-6 max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-serif text-foreground mb-4">
              Nuestros Cuatro Pilares
            </h2>
            <p className="text-lg text-muted-foreground">
              La esencia de nuestra marca se fundamenta en valores inquebrantables que guían cada paso de nuestro proceso, desde el olivar hasta su mesa.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
            {pillars.map((pillar, i) => <div key={i} data-index={i} className="h-full">
                <Card className="h-full bg-secondary/30 border-none shadow-none hover:bg-secondary/50 transition-colors duration-300">
                  <CardContent className="flex flex-col items-center text-center p-8 md:p-10 h-full">
                    <div className="mb-6 p-4 rounded-full bg-primary/10 text-primary-700">
                      {pillar.icon}
                    </div>
                    <h3 className="text-2xl font-serif text-foreground mb-4">
                      {pillar.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {pillar.description}
                    </p>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}